module.exports = __webpack_public_path__ + "media/stylesheets/images/Yoshihiko Kino-5157e414587578c7146f5598cb16f9e9.jpg";